<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <label class="control-label">Escopo</label>
    </div>
    <div class="panel-body filters__form">
      <loading v-if="loading" full-parent size="small" />
      <div class="row">
        <div class="col-md-1">
          <input-field
            label="Campus"
            type="number"
            placeholder="ID do QP"
            v-model.number="form.get('campusId').value"
            :errors="form.get('campusId').errors"
            @input="emitFormFieldChanged('campusId')"
            :disabled="disabledForm"
          />
        </div>
        <div class="col-md-1">
          <input-field
            label="Curso"
            type="number"
            placeholder="ID do QP"
            v-model.number="form.get('courseId').value"
            :errors="form.get('courseId').errors"
            @input="emitFormFieldChanged('courseId')"
            :disabled="disabledForm"
          />
        </div>
        <div class="col-md-2">
          <select-field
            label="Nível"
            placeholder=" "
            :options="levelTypes"
            v-model.number="form.get('levelId').value"
            :errors="form.get('levelId').errors"
            @input="emitFormFieldChanged('levelId')"
            :disabled="disabledForm"
          />
        </div>
        <div class="col-md-2">
          <select-field
            label="Modalidade"
            placeholder=" "
            :options="kindTypes"
            v-model.number="form.get('kindId').value"
            :errors="form.get('kindId').errors"
            @input="emitFormFieldChanged('kindId')"
            :disabled="disabledForm"
          />
        </div>
        <div class="col-md-2">
          <select-field
            label="Turno"
            placeholder=" "
            :options="shiftTypes"
            v-model.number="form.get('shiftId').value"
            :errors="form.get('shiftId').errors"
            @input="emitFormFieldChanged('shiftId')"
            :disabled="disabledForm"
          />
        </div>
        <div class="col-md-2">
          <input-field
            label="Semestre"
            placeholder="Exemplo 2021.1"
            :mask="['####.#', '####.##']"
            v-model="form.get('enrollmentSemester').value"
            :errors="form.get('enrollmentSemester').errors"
            @input="emitFormFieldChanged('enrollmentSemester')"
            :disabled="disabledForm"
          />
        </div>
        <div class="col-md-1">
          <select-field
            label="Origem"
            placeholder=" "
            :options="originTypes"
            v-model="form.get('origin').value"
            :errors="form.get('origin').errors"
            @input="emitFormFieldChanged('origin')"
            :disabled="disabledForm"
          />
        </div>
        <div class="col-md-1">
          <input-field
            label="Prioridade"
            type="number"
            v-model.number="form.get('priority').value"
            :errors="form.get('priority').errors"
            @input="emitFormFieldChanged('priority')"
            :disabled="disabledForm"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { InputField, SelectField } from 'components/form';
import EnumsService from 'services/EnumsService';
import Loading from 'components/Loading';

export default {
  components: {
    InputField,
    SelectField,
    Loading,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    disabledForm: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      originTypes: [],
      kindTypes: [],
      shiftTypes: [],
      levelTypes: [],
      loading: false,
    };
  },
  mounted() {
    this.loading = true;

    Promise.all([
      this.getOriginTypes(),
      this.getKindTypes(),
      this.getShiftTypes(),
      this.getLevelTypes(),
    ])
      .catch(() => {
        this.$router.push('/');
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    getOriginTypes() {
      return EnumsService.getOriginTypes()
        .then((originTypes) => {
          this.originTypes = originTypes;
        });
    },
    getKindTypes() {
      return EnumsService.getKindTypes()
        .then((kindTypes) => {
          this.kindTypes = kindTypes;
        });
    },
    getShiftTypes() {
      return EnumsService.getShiftTypes()
        .then((shiftTypes) => {
          this.shiftTypes = shiftTypes;
        });
    },
    getLevelTypes() {
      return EnumsService.getLevelTypes()
        .then((levelTypes) => {
          this.levelTypes = levelTypes;
        });
    },
    emitFormFieldChanged(field) {
      this.$emit('form-field-changed', { [field]: this.form.get(field).value });
    },
  },
};
</script>
<style lang="scss" scoped>
  @import 'assets/stylesheets/utils/_spacing.sass';

  .filters__form {
    padding: $space-m $space-st $space-xxs $space-st;
    position: relative;
  }
</style>
